require('isomorphic-fetch')
const catchLinks = require('./catch-links')

module.exports = {
  onClientEntry: () => {
    catchLinks(window, (anchor, path) => {
      if (window.tripleAppUrlScheme && window.tripleAppUrlScheme !== 'triple') {
        anchor.href = `${window.tripleAppUrlScheme}:${
          path.match(/^\/\/\//) ? '' : '//'
        }${path}`
      }
    })
  },
}
